<ag-grid-angular
  class="ag-theme-quartz"
  [rowData]="rowData"
  [defaultColDef]="defaultColDef"
  [gridOptions]="gridOptions"
  [pinnedTopRowData]="pinnedTopRowData"
  [rowSelection]="defaultRowSelection"
  (gridReady)="gridReady($event)"
  (cellEditingStopped)="onCellEditingStopped($event)"
  (cellKeyDown)="onKeyDown($event)"
  (cellFocused)="onCellFocused($event)"
  domLayout="autoHeight"
/>
